module.exports = __webpack_public_path__ + "img/Triticum_aestivum.1d7ce247.jpg";